module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/contacts_plus-88e7a663fdb5dd4d6b5859c25b37b245.svg";